module.exports = __webpack_public_path__ + "static/media/grayPencil.fdd36ec2.svg";